<div class="media-thumbnail" (click)="openMediaPreview()" (keydown.enter)="openMediaPreview()" (keydown.space)="$event.preventDefault(); openMediaPreview()" data-cy="play-video" tabindex="0" role="button" [attr.aria-label]="'feedback-creator_media-thumbnail' | translate: {title: media.title}">
  @switch (type) {
    @case ('image') {
      <div class="image-container" [ngClass]="{'gray-background': media.media_status !== 'ready'}">
        @if (media.media_status === 'ready') {
          <img
            class="image-thumbnail"
            src="{{media.media_url}}"
            alt="Image Thumbnail" />
        }
        @if (media.media_status !== 'ready') {
          <i class="ficon-image-filled"></i>
        }
      </div>
    }
    @case ('video') {
      <div class="video-container" [ngClass]="{'default-container': media.media_status === 'pending'}">
        @if (media.media_status === 'pending') {
          <i class="ficon-spinner ficon-spin" data-cy="media-pending"></i>
        } @else {
          @if (media.thumbnail_url) {
            <img
              data-cy="media-success"
              class="video-thumbnail"
              [attr.crossorigin]="media.isYoutube() ? null : 'anonymous'"
              src="{{media.thumbnail_url}}"
              alt="Media Thumbnail" />
          }
          <div class="play-overlay">
            <i class="ficon-play"></i>
          </div>
        }
      </div>
    }
    @case ('audio') {
      <div class="audio-container">
        @if (media.media_status === 'pending') {
          <i class="ficon-spinner ficon-spin" data-cy="media-pending"></i>
        } @else {
          <i class="ficon-microphone-outlined"></i>
          <div class="play-overlay">
            <i class="ficon-play"></i>
          </div>
        }
      </div>
    }
    @case ('document') {
      <div class="document-container">
        <i class="ficon-document-filled"></i>
      </div>
    }
    @default {
      <div class="default-container">
        <i class="ficon-spinner ficon-spin" data-cy="media-pending"></i>
      </div>
    }
  }
</div>
@if (removeEvent.observers.length > 0) {
  <button
    type="button"
    class="remove-btn"
    attr.aria-label="{{'common_remove'| translate}}"
    [matTooltip]="'feedback-creator_remove-attachment' | translate"
    (click)="removeEvent.emit(media)">
    <i class="ficon-app-x"></i>
  </button>
}
